exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".empty-viewer {\n  margin-top: 80px;\n}\n.bi-head {\n  padding-bottom: 0 !important;\n}\n#diagram-viewer.loaded {\n  margin-top: 10px;\n  height: 500px;\n  line-height: 500px;\n}\n#diagram-viewer .bjs-powered-by {\n  bottom: -200px !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./App/Components/DiagramViewer/diagram-viewer.less
// module id = 299
// module chunks = 0